/* eslint-disable @typescript-eslint/no-empty-function */
import { ChangeDetectorRef, Directive, ElementRef, forwardRef, HostListener, inject, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { isNil } from 'lodash';

import { YesNo, YesNoEnum } from '@shared/model/yes-no.model';
// TODO: Check if we can reuse ControlValueAccessorBaseDirective here;

@Directive({
  selector: '[appYesNoValueCheckbox]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => YesNoValueCheckboxDirective),
      multi: true,
    },
  ],
})
export class YesNoValueCheckboxDirective implements ControlValueAccessor {
  @HostListener('input', ['$event.target.checked'])
  onInput(value: boolean): void {
    this.updateValue(value);
  }

  private el = inject(ElementRef<HTMLInputElement>);
  private renderer = inject(Renderer2);
  private changeDetectorRef = inject(ChangeDetectorRef);

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: YesNo): void {
    this.renderer.setProperty(this.el.nativeElement, 'checked', value === YesNoEnum.Y);
    isNil(value) && this.updateValue(false);
    this.changeDetectorRef.detectChanges();
  }

  registerOnChange(fn: (value: YesNo) => void): void {
    this.onChange = (value: boolean): void => {
      fn(value ? YesNoEnum.Y : YesNoEnum.N);
    };
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
  }

  private updateValue(value: boolean): void {
    this.onChange(value);
    this.onTouched();
  }
}
